import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, CreditCard, Wrench, MessageCircle, MoreHorizontal, Building2 } from "lucide-react";

/**
 * MobileTabBar — fixed bottom navigation for logged-in tenants and
 * landlords on small screens. Uses the same clean card-tab pattern as
 * modern consumer PWAs (Pill Pack, Notion Home, etc.).
 *
 * Hidden on lg+ where the sidebar handles navigation.
 */
export default function MobileTabBar({ role }) {
  const loc = useLocation();
  const path = loc.pathname || "";

  const tabs = role === "tenant"
    ? [
        { to: "/dashboard",      Icon: LayoutDashboard, label: "Home",    match: (p) => p === "/dashboard" },
        { to: "/tenant/rent",    Icon: CreditCard,      label: "Rent",    match: (p) => p.startsWith("/tenant/rent") || p.startsWith("/payments") },
        { to: "/maintenance",    Icon: Wrench,          label: "Repairs", match: (p) => p.startsWith("/maintenance") },
        { to: "/messages",       Icon: MessageCircle,   label: "Chat",    match: (p) => p.startsWith("/messages") },
        { to: "/tenant/toolkit", Icon: MoreHorizontal,  label: "More",    match: (p) => p.startsWith("/tenant") && !p.startsWith("/tenant/rent") && !p.startsWith("/tenant/toolkit") ? false : p.startsWith("/tenant/toolkit") },
      ]
    : [
        { to: "/dashboard",   Icon: LayoutDashboard, label: "Home",   match: (p) => p === "/dashboard" },
        { to: "/properties",  Icon: Building2,       label: "Units",  match: (p) => p.startsWith("/properties") },
        { to: "/payments",    Icon: CreditCard,      label: "Rent",   match: (p) => p.startsWith("/payments") || p.startsWith("/books") },
        { to: "/messages",    Icon: MessageCircle,   label: "Chat",   match: (p) => p.startsWith("/messages") },
        { to: "/copilot",     Icon: MoreHorizontal,  label: "More",   match: (p) => p.startsWith("/copilot") || p.startsWith("/agent-settings") },
      ];

  return (
    <nav
      data-testid="mobile-tab-bar"
      aria-label="Primary"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-5 max-w-md mx-auto">
        {tabs.map((t) => {
          const active = t.match(path);
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={`mobile-tab-${t.label.toLowerCase()}`}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 transition-colors ${
                active ? "text-emerald-700" : "text-slate-500 hover:text-slate-900"
              }`}
            >
              <t.Icon className={`w-5 h-5 ${active ? "" : "opacity-80"}`} />
              <span className={`text-[11px] ${active ? "font-bold" : "font-medium"}`}>{t.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
